import { render } from "./CommentForm.vue?vue&type=template&id=72ee8928"
import script from "./CommentForm.vue?vue&type=script&lang=js"
export * from "./CommentForm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/CommentForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72ee8928"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72ee8928', __exports__)) {
    api.reload('72ee8928', __exports__)
  }
  
  module.hot.accept("./CommentForm.vue?vue&type=template&id=72ee8928", () => {
    api.rerender('72ee8928', render)
  })

}


export default __exports__